import { createDataModule } from '@perpay-web/data-module/createDataModule';
import {
    marketplacePartnerOnboardingSignup,
    marketplacePartnerOnboardingSignupReset,
    marketplacePartnerOnboardingSignupSuccess,
    marketplacePartnerOnboardingSignupError,
} from '@perpay-web/fintech/actions/entities/marketplacePartnerOnboarding';

const MarketplacePartnerOnboardingSignupDataModule = createDataModule({
    dataRequest: marketplacePartnerOnboardingSignup,
    dataSuccess: marketplacePartnerOnboardingSignupSuccess,
    dataError: marketplacePartnerOnboardingSignupError,
    dataReset: marketplacePartnerOnboardingSignupReset,
});

const getRoot = (state) => state.dataModules.marketplacePartnerOnboardingSignup;
const initialValue = {
    isExistingUser: false,
    errors: {},
};
export const marketplacePartnerOnboardingSignupDataModule =
    MarketplacePartnerOnboardingSignupDataModule({
        getRoot,
        initialValue,
    });
